/* ============================================================
   WIMBUSH CUSTOM JS — FINAL WORKING VERSION
   Wishlist + Quick View Modal + Shopify Cart Integration
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     WISHLIST — localStorage based
     ============================================================ */

  const WISHLIST_KEY = 'wimbush_wishlist';

  function getWishlist() {
    try {
      const stored = localStorage.getItem(WISHLIST_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
      updateWishlistBadges();
    } catch (e) {
      console.warn('[Wimbush] Wishlist save failed:', e);
    }
  }

  function isInWishlist(productId) {
    return getWishlist().some((item) => String(item.id) === String(productId));
  }

  function addToWishlist(product) {
    const list = getWishlist();
    if (!list.some((item) => String(item.id) === String(product.id))) {
      list.push(product);
      saveWishlist(list);
    }
  }

  function removeFromWishlist(productId) {
    const list = getWishlist().filter((item) => String(item.id) !== String(productId));
    saveWishlist(list);
  }

  function toggleWishlist(productId, productHandle, button) {
    if (isInWishlist(productId)) {
      removeFromWishlist(productId);
      button.classList.remove('is-active');
      const icon = button.querySelector('i');
      if (icon) {
        icon.classList.remove('fas');
        icon.classList.add('far');
      }
    } else {
      addToWishlist({ id: productId, handle: productHandle });
      button.classList.add('is-active');
      const icon = button.querySelector('i');
      if (icon) {
        icon.classList.remove('far');
        icon.classList.add('fas');
      }
    }
  }

  function updateWishlistBadges() {
    const count = getWishlist().length;
    document
      .querySelectorAll('.wimbush-wishlist-badge, [data-wishlist-badge], .wishlist-badge, [data-wishlist-count]')
      .forEach((badge) => {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      });
  }

  function initWishlistButtons() {
    document.querySelectorAll('.custom-fp-wishlist').forEach((button) => {
      if (button.dataset.wishlistInit === 'true') return;
      button.dataset.wishlistInit = 'true';

      const productId = button.dataset.productId;
      const productHandle = button.dataset.productHandle;

      if (isInWishlist(productId)) {
        button.classList.add('is-active');
        const icon = button.querySelector('i');
        if (icon) {
          icon.classList.remove('far');
          icon.classList.add('fas');
        }
      }

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        button.style.transform = 'scale(0.85)';
        setTimeout(() => {
          button.style.transform = '';
        }, 150);

        toggleWishlist(productId, productHandle, button);
      });
    });

    updateWishlistBadges();
  }

  /* ============================================================
     QUICK VIEW MODAL
     ============================================================ */

  let fpModal = null;
  let fpModalImg = null;
  let fpModalCat = null;
  let fpModalTitle = null;
  let fpModalPrice = null;
  let fpModalDesc = null;
  let fpModalSizes = null;
  let fpModalSizeButtons = null;
  let fpModalAdd = null;
  let fpModalNote = null;

  let currentProduct = null;
  let selectedSize = null;

  function cacheModalElements() {
    fpModal = document.getElementById('customFpModal');
    fpModalImg = document.getElementById('customFpModalImg');
    fpModalCat = document.getElementById('customFpModalCat');
    fpModalTitle = document.getElementById('customFpModalTitle');
    fpModalPrice = document.getElementById('customFpModalPrice');
    fpModalDesc = document.getElementById('customFpModalDesc');
    fpModalSizes = document.getElementById('customFpModalSizes');
    fpModalSizeButtons = document.getElementById('customFpModalSizeButtons');
    fpModalAdd = document.getElementById('customFpModalAdd');
    fpModalNote = document.getElementById('customFpModalNote');
  }

  function openQuickView(productData) {
    if (!fpModal) return;
    currentProduct = productData;
    selectedSize = null;

    fpModalImg.style.backgroundImage = "url('" + productData.image + "')";
    fpModalCat.textContent = productData.type || 'Leather Essentials';
    fpModalTitle.textContent = productData.title;

    let priceHtml = productData.price;
    if (productData.compare_at_price && productData.compare_at_price !== productData.price) {
      priceHtml += ' <span class="alt">/ ' + productData.compare_at_price + '</span>';
    }
    fpModalPrice.innerHTML = priceHtml;

    fpModalDesc.textContent =
      productData.description || 'A refined everyday piece, crafted from premium leather.';

    // Reset size section
    if (fpModalSizeButtons) fpModalSizeButtons.innerHTML = '';
    if (fpModalAdd) {
      fpModalAdd.disabled = false;
      fpModalAdd.style.opacity = '1';
      fpModalAdd.style.cursor = 'pointer';
      fpModalAdd.style.background = '';
      fpModalAdd.style.borderColor = '';
      fpModalAdd.querySelector('span').textContent = 'Add to Cart';
    }

    // Size selector for jackets
    if (productData.is_jacket && productData.variants && productData.variants.length > 0) {
      fpModalSizes.style.display = 'block';
      fpModalAdd.disabled = true;
      fpModalAdd.style.opacity = '0.5';
      fpModalAdd.style.cursor = 'not-allowed';
      fpModalAdd.querySelector('span').textContent = 'Select a Size';
      fpModalNote.textContent =
        'By adding to cart, you acknowledge this is a made-to-order item. Production begins after checkout.';

      productData.variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'custom-fp-modal__size-btn';
        btn.textContent = variant.title;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;

        btn.addEventListener('click', function () {
          fpModalSizeButtons
            .querySelectorAll('.custom-fp-modal__size-btn')
            .forEach((b) => b.classList.remove('is-selected'));
          this.classList.add('is-selected');
          selectedSize = this.dataset.variantId;
          fpModalAdd.disabled = false;
          fpModalAdd.style.opacity = '1';
          fpModalAdd.style.cursor = 'pointer';
          fpModalAdd.querySelector('span').textContent = 'Add to Cart — ' + this.textContent;
        });

        fpModalSizeButtons.appendChild(btn);
      });
    } else {
      fpModalSizes.style.display = 'none';
      fpModalNote.textContent = 'Free UK delivery on orders over £50. Personalisation available at checkout.';
    }

    fpModal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeQuickView() {
    if (!fpModal) return;
    fpModal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  function initQuickView() {
    // Event delegation — anywhere on document
    document.removeEventListener('click', handleQuickViewClick);
    document.addEventListener('click', handleQuickViewClick);

    document.removeEventListener('keydown', handleQuickViewEscape);
    document.addEventListener('keydown', handleQuickViewEscape);

    if (fpModal) {
      fpModal.querySelectorAll('[data-close-modal]').forEach((el) => {
        el.removeEventListener('click', closeQuickView);
        el.addEventListener('click', closeQuickView);
      });
    }

    if (fpModalAdd) {
      fpModalAdd.removeEventListener('click', handleModalAddToCart);
      fpModalAdd.addEventListener('click', handleModalAddToCart);
    }
  }

  function handleQuickViewClick(e) {
    const link = e.target.closest('[data-open-modal]');
    if (!link) return;

    e.preventDefault();
    e.stopPropagation();

    const card = link.closest('.custom-fp-card');
    if (!card) return;

    const jsonScript = card.querySelector('[data-product-json]');
    if (!jsonScript) {
      console.warn('[Wimbush] No product JSON found');
      return;
    }

    try {
      const productData = JSON.parse(jsonScript.textContent);
      openQuickView(productData);
    } catch (err) {
      console.error('[Wimbush] Product data parse error:', err);
    }
  }

  function handleQuickViewEscape(e) {
    if (e.key === 'Escape' && fpModal && fpModal.classList.contains('is-active')) {
      closeQuickView();
    }
  }

  /* ============================================================
     SHOPIFY CART INTEGRATION
     ============================================================ */

  async function addToShopifyCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId), quantity: quantity }]
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.description || 'Cart API failed');
      }

      const cartData = await response.json();
      await updateWimbushCartCount();

      // Dispatch events for Atelier theme
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cartData }));
      document.dispatchEvent(
        new CustomEvent('cart:lines:update', {
          bubbles: true,
          detail: {
            action: 'add',
            lines: cartData.items,
            promise: Promise.resolve({ detail: { didError: false } })
          }
        })
      );

      return { success: true, cart: cartData };
    } catch (error) {
      console.error('[Wimbush] Add to cart error:', error);
      return { success: false, error: error.message };
    }
  }

  async function updateWimbushCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const count = cart.item_count;

      document
        .querySelectorAll(
          '.cart-bubble__text, .cart-count-bubble, [data-cart-count], .cart-bubble__text-count, .cart-count, .theme-drawer__badge'
        )
        .forEach((badge) => {
          badge.textContent = count;
          if (count > 0) {
            badge.style.display = '';
            badge.classList.remove('hidden', 'visually-hidden');
          }
        });

      return count;
    } catch (error) {
      return 0;
    }
  }

  /* ============================================================
     REFRESH CART DRAWER — Force re-render with latest cart data
     ============================================================ */

  async function refreshCartDrawer() {
    try {
      // Fetch the latest cart drawer section from Shopify
      const sectionResponse = await fetch('/?section_id=cart-drawer-section');
      const sectionHTML = await sectionResponse.text();

      const parser = new DOMParser();
      const newDoc = parser.parseFromString(sectionHTML, 'text/html');

      // Find the new cart drawer content
      const newDrawer = newDoc.querySelector('#shopify-section-cart-drawer-section');
      const oldDrawer = document.querySelector('#shopify-section-cart-drawer-section');

      if (newDrawer && oldDrawer) {
        // Replace old drawer's inner HTML with new one
        oldDrawer.innerHTML = newDrawer.innerHTML;

        // Re-cache after replacement
        cacheModalElements();
        initQuickView();

        console.log('[Wimbush] ✅ Cart drawer content refreshed');
      }

      // Force open the cart drawer
      const cartDrawer = document.querySelector('theme-drawer#cart-drawer');
      if (cartDrawer) {
        // Try Atelier's native open method
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: manually trigger
          const dialog = cartDrawer.querySelector('dialog');
          if (dialog && !dialog.hasAttribute('open')) {
            dialog.setAttribute('open', '');
            cartDrawer.setAttribute('open', '');
          }
        }
        console.log('[Wimbush] ✅ Cart drawer opened');
      }
    } catch (err) {
      console.warn('[Wimbush] Cart drawer refresh failed:', err);
      // Fallback: reload the page with cart drawer state
      // window.location.reload();
    }
  }

  /* ============================================================
     HANDLE MODAL ADD TO CART
     ============================================================ */

  async function handleModalAddToCart() {
    if (!currentProduct) return;

    let variantId = null;
    if (selectedSize) {
      variantId = selectedSize;
    } else if (currentProduct.variants && currentProduct.variants.length > 0) {
      const firstAvailable =
        currentProduct.variants.find((v) => v.available) || currentProduct.variants[0];
      variantId = firstAvailable.id;
    }

    if (!variantId) {
      alert('Sorry, this product is not available.');
      return;
    }

    const button = fpModalAdd;
    const originalText = button.querySelector('span').textContent;

    button.querySelector('span').textContent = 'Adding...';
    button.disabled = true;
    button.style.opacity = '0.7';

    const result = await addToShopifyCart(variantId, 1);

    if (result.success) {
      button.querySelector('span').textContent = '✓ Added to Cart';
      button.style.background = '#0F3B36';
      button.style.borderColor = '#0F3B36';
      button.style.opacity = '1';

      // Close modal and refresh cart drawer
      setTimeout(async () => {
        closeQuickView();

        // Refresh cart drawer with new data
        await refreshCartDrawer();

        // Reset button
        button.querySelector('span').textContent = originalText;
        button.style.background = '';
        button.style.borderColor = '';
        button.disabled = false;
        selectedSize = null;
        if (fpModalSizeButtons) {
          fpModalSizeButtons
            .querySelectorAll('.custom-fp-modal__size-btn')
            .forEach((b) => b.classList.remove('is-selected'));
        }
      }, 800);
    } else {
      button.querySelector('span').textContent = 'Try Again';
      button.style.background = '#a33';
      button.style.borderColor = '#a33';
      button.style.opacity = '1';

      setTimeout(() => {
        button.querySelector('span').textContent = originalText;
        button.style.background = '';
        button.style.borderColor = '';
        button.disabled = false;
      }, 2000);
    }
  }

  /* ============================================================
     INITIALIZATION
     ============================================================ */

  function init() {
    cacheModalElements();
    initWishlistButtons();
    initQuickView();
    updateWimbushCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify editor support
  document.addEventListener('shopify:section:load', function () {
    cacheModalElements();
    initWishlistButtons();
    updateWimbushCartCount();
  });
})();

/* ============================================================
   WIMBUSH — LEATHER JACKETS (100% Dynamic + Cursor Fixed)
   ============================================================ */

(function () {
  'use strict';

  let currentData = null;
  let selectedVariantId = null;
  let selectedCustomSize = null;

  /* ============================================================
     HELPER: Button State Setter
     ============================================================ */
  function setAddButtonState(state, text) {
    const addBtn = document.getElementById('customJacketModalAdd');
    if (!addBtn) return;
    const addBtnSpan = addBtn.querySelector('span');

    if (state === 'disabled') {
      addBtn.disabled = true;
      addBtn.style.opacity = '0.5';
      addBtn.style.cursor = 'not-allowed';
      addBtn.style.background = '';
      addBtn.style.borderColor = '';
      if (addBtnSpan) addBtnSpan.textContent = text || 'Select a Size';
    } else if (state === 'enabled') {
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
      addBtn.style.cursor = 'pointer';
      addBtn.style.background = '';
      addBtn.style.borderColor = '';
      if (addBtnSpan) addBtnSpan.textContent = text || 'Add to Cart';
    } else if (state === 'loading') {
      addBtn.disabled = true;
      addBtn.style.opacity = '0.7';
      addBtn.style.cursor = 'wait';
      if (addBtnSpan) addBtnSpan.textContent = 'Adding...';
    } else if (state === 'success') {
      addBtn.disabled = true;
      addBtn.style.opacity = '1';
      addBtn.style.cursor = 'default';
      addBtn.style.background = '#0F3B36';
      addBtn.style.borderColor = '#0F3B36';
      if (addBtnSpan) addBtnSpan.textContent = '✓ Added to Cart';
    } else if (state === 'error') {
      addBtn.disabled = false;
      addBtn.style.opacity = '1';
      addBtn.style.cursor = 'pointer';
      addBtn.style.background = '#a33';
      addBtn.style.borderColor = '#a33';
      if (addBtnSpan) addBtnSpan.textContent = 'Try Again';
    }
  }

  /* ============================================================
     OPEN MODAL
     ============================================================ */
  function openModal(data) {
    const modal = document.getElementById('customJacketModal');
    if (!modal) return;

    currentData = data;
    selectedVariantId = null;
    selectedCustomSize = null;

    // Populate basic info
    document.getElementById('customJacketModalCat').textContent = data.cat || '';
    document.getElementById('customJacketModalTitle').textContent = data.name || '';
    document.getElementById('customJacketModalPrice').textContent = data.price || '';
    document.getElementById('customJacketModalPriceAlt').textContent =
      data.priceAlt ? '/ ' + data.priceAlt : '';
    document.getElementById('customJacketModalDesc').textContent = data.desc || '';

    const imgEl = document.getElementById('customJacketModalImg');
    if (imgEl) imgEl.style.backgroundImage = `url('${data.img}')`;

    // Reset sizes
    const sizesWrap = document.getElementById('customJacketModalSizeButtons');
    sizesWrap.innerHTML = '';

    // Reset custom size fields
    const customFields = modal.querySelector('.custom-size-fields');
    const customToggle = modal.querySelector('.custom-size-toggle');
    if (customFields) customFields.classList.remove('is-open');
    if (customToggle) customToggle.classList.remove('is-open');
    modal.querySelectorAll('.custom-size-input').forEach((inp) => (inp.value = ''));

    // No product linked
    if (!data.hasProduct || !data.variants || data.variants.length === 0) {
      sizesWrap.innerHTML =
        '<p style="color:#a33; font-size:0.85rem; text-align:center; padding:10px;">' +
        '⚠️ No product linked. Please select a product in the section settings.' +
        '</p>';

      setAddButtonState('disabled', 'Product Not Linked');
      modal.classList.add('is-active');
      document.body.style.overflow = 'hidden';
      return;
    }

    // Render dynamic variants
    data.variants.forEach((variant) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'modal-size-btn';
      btn.textContent = variant.title;
      btn.dataset.variantId = variant.id;

      // If variant not available, still show it but style differently
      if (!variant.available) {
        btn.classList.add('is-unavailable');
        btn.style.opacity = '0.35';
        btn.style.cursor = 'not-allowed';
        btn.title = 'Out of stock';
      }

      btn.addEventListener('click', function () {
        // Block click if unavailable
        if (this.classList.contains('is-unavailable')) {
          return;
        }

        // Deselect all
        sizesWrap.querySelectorAll('.modal-size-btn').forEach((b) => b.classList.remove('is-selected'));
        this.classList.add('is-selected');

        selectedVariantId = this.dataset.variantId;
        selectedCustomSize = null;

        // Close custom size
        if (customFields) customFields.classList.remove('is-open');
        if (customToggle) customToggle.classList.remove('is-open');

        // ✅ ENABLE Add to Cart button
        setAddButtonState('enabled', 'Add to Cart — ' + this.textContent);
      });

      sizesWrap.appendChild(btn);
    });

    // Reset Add to Cart button
    setAddButtonState('disabled', 'Select a Size');

    modal.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    const modal = document.getElementById('customJacketModal');
    if (!modal) return;
    modal.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ============================================================
     CUSTOM SIZE TOGGLE + INPUTS
     ============================================================ */
  function initCustomSize() {
    const modal = document.getElementById('customJacketModal');
    if (!modal) return;

    const toggle = modal.querySelector('.custom-size-toggle');
    const fields = modal.querySelector('.custom-size-fields');
    const sizesWrap = document.getElementById('customJacketModalSizeButtons');

    if (toggle && !toggle.dataset.init) {
      toggle.dataset.init = 'true';
      toggle.addEventListener('click', function () {
        const isOpen = fields.classList.contains('is-open');
        fields.classList.toggle('is-open');
        toggle.classList.toggle('is-open');

        if (!isOpen) {
          // Opened custom size → deselect standard sizes
          sizesWrap.querySelectorAll('.modal-size-btn').forEach((b) => b.classList.remove('is-selected'));
          selectedVariantId = null;
          setAddButtonState('disabled', 'Enter Chest & Waist');
        } else {
          // Closed custom size → reset
          selectedCustomSize = null;
          setAddButtonState('disabled', 'Select a Size');
        }
      });
    }

    modal.querySelectorAll('.custom-size-input').forEach((input) => {
      if (input.dataset.init) return;
      input.dataset.init = 'true';

      input.addEventListener('input', function () {
        const values = {};
        modal.querySelectorAll('.custom-size-input').forEach((inp) => {
          values[inp.dataset.field] = inp.value.trim();
        });
        selectedCustomSize = values;

        // Find first available variant ID (base for custom size)
        let baseVariantId = null;
        if (currentData && currentData.variants && currentData.variants.length > 0) {
          const avail = currentData.variants.find((v) => v.available && v.id);
          if (avail) baseVariantId = avail.id;
        }

        const hasBase = !!baseVariantId;

        if (values.chest && values.waist && hasBase) {
          setAddButtonState('enabled', 'Add to Cart — Custom Size');
        } else if (!hasBase) {
          setAddButtonState('disabled', 'Custom Size Unavailable');
        } else {
          setAddButtonState('disabled', 'Enter Chest & Waist');
        }
      });
    });
  }

  /* ============================================================
     ADD TO CART
     ============================================================ */
  async function handleAddToCart() {
    if (!currentData) return;

    const addBtn = document.getElementById('customJacketModalAdd');
    const addBtnSpan = addBtn.querySelector('span');
    const originalText = addBtnSpan.textContent;

    const customToggle = document.querySelector('#customJacketModal .custom-size-toggle.is-open');
    const isCustom = !!customToggle;

    let variantId = null;
    let properties = null;

    if (isCustom) {
      // Custom size flow
      if (!selectedCustomSize || !selectedCustomSize.chest || !selectedCustomSize.waist) {
        alert('Please enter Chest and Waist measurements.');
        return;
      }

      if (currentData.variants && currentData.variants.length > 0) {
        const avail = currentData.variants.find((v) => v.available && v.id);
        if (avail) variantId = avail.id;
      }

      if (!variantId) {
        alert('Custom size is not available for this product.');
        return;
      }

      properties = {
        'Custom Size': 'Yes',
        Chest: selectedCustomSize.chest + ' in',
        Waist: selectedCustomSize.waist + ' in',
      };
      if (selectedCustomSize.sleeve) properties.Sleeve = selectedCustomSize.sleeve + ' in';
      if (selectedCustomSize.length) properties.Length = selectedCustomSize.length + ' in';
      if (selectedCustomSize.notes) properties.Notes = selectedCustomSize.notes;
    } else {
      // Standard size
      variantId = selectedVariantId;
      if (!variantId) {
        alert('Please select a size.');
        return;
      }
    }

    setAddButtonState('loading');

    const result = await addToCart(variantId, properties);

    if (result.success) {
      setAddButtonState('success');

      setTimeout(() => {
        closeModal();
        refreshCartDrawer();
        setAddButtonState('disabled', 'Select a Size');
        selectedVariantId = null;
        selectedCustomSize = null;
      }, 900);
    } else {
      setAddButtonState('error');

      setTimeout(() => {
        // Restore to whatever was selected
        if (isCustom) {
          setAddButtonState('enabled', 'Add to Cart — Custom Size');
        } else if (selectedVariantId) {
          const selectedBtn = document.querySelector('.modal-size-btn.is-selected');
          setAddButtonState('enabled', 'Add to Cart — ' + (selectedBtn ? selectedBtn.textContent : ''));
        } else {
          setAddButtonState('disabled', 'Select a Size');
        }
      }, 2000);
    }
  }

  async function addToCart(variantId, properties) {
    try {
      const item = { id: parseInt(variantId, 10), quantity: 1 };
      if (properties) item.properties = properties;

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Cart error');
      }

      const data = await res.json();

      // Update cart count badges
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document
        .querySelectorAll(
          '.cart-bubble__text, .cart-count-bubble, [data-cart-count], .cart-count, .theme-drawer__badge'
        )
        .forEach((b) => {
          b.textContent = cart.item_count;
          if (cart.item_count > 0) {
            b.style.display = '';
            b.classList.remove('hidden');
          }
        });

      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
      document.dispatchEvent(
        new CustomEvent('cart:lines:update', {
          bubbles: true,
          detail: { action: 'add', lines: data.items }
        })
      );

      return { success: true };
    } catch (err) {
      console.error('[Wimbush] Cart error:', err);
      return { success: false, error: err.message };
    }
  }

  async function refreshCartDrawer() {
    try {
      const drawer = document.querySelector('theme-drawer#cart-drawer, cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        // Try to open dialog-based drawer
        const dialog = document.querySelector('cart-drawer dialog, theme-drawer dialog');
        if (dialog && !dialog.hasAttribute('open')) {
          dialog.setAttribute('open', '');
          const parent = dialog.closest('cart-drawer, theme-drawer');
          if (parent) parent.setAttribute('open', '');
        }
      }
    } catch (e) {}
  }

  /* ============================================================
     EVENT BINDING
     ============================================================ */
  function init() {
    // Card click → open modal
    document.addEventListener('click', function (e) {
      const card = e.target.closest('.custom-lj-card');
      if (!card) return;

      // Ignore if clicked on wishlist (agar future mein add karo)
      if (e.target.closest('.custom-lj-wishlist')) return;

      e.preventDefault();
      const key = card.dataset.jacket;
      const script = document.querySelector(`script[data-jacket-data="${key}"]`);
      if (!script) return;

      try {
        const data = JSON.parse(script.textContent);
        openModal(data);
        initCustomSize();
      } catch (err) {
        console.error('[Wimbush] JSON parse error:', err);
      }
    });

    // Close buttons
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-close-modal]')) {
        closeModal();
      }
    });

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });

    // Add to Cart button
    const addBtn = document.getElementById('customJacketModalAdd');
    if (addBtn && !addBtn.dataset.init) {
      addBtn.dataset.init = 'true';
      addBtn.addEventListener('click', handleAddToCart);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();